import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <div className="hero-section">
        <h1 className="hero-title">北海红色人物数字博物馆</h1>
        <p className="hero-subtitle">传承红色基因，弘扬革命精神</p>
      </div>

      <div className="features-grid">
        <Link to="/heroes" className="feature-card">
          <div className="feature-icon">🏛️</div>
          <h2>英雄档案馆</h2>
          <p>了解北海红色英雄的光辉事迹</p>
        </Link>

        <Link to="/quiz" className="feature-card">
          <div className="feature-icon">🎯</div>
          <h2>答题闯关区</h2>
          <p>通过答题学习红色文化知识</p>
        </Link>

        <Link to="/workshop" className="feature-card">
          <div className="feature-icon">🎨</div>
          <h2>红色创客营</h2>
          <p>创作和分享红色文化作品</p>
        </Link>
      </div>

      <div className="intro-section">
        <h2>关于我们</h2>
        <p>
          北海红色人物数字博物馆致力于传承和弘扬红色文化，通过数字化手段
          让更多人了解和学习北海地区的红色历史，感受革命先烈的伟大精神。
        </p>
      </div>
    </div>
  );
};

export default Home;

